import { FaEnvelope, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import image_main from "../../assets/main/main_logo.png";
import "./Footer.css";

export default function Footer({ user, openLoginModal }) {
        return (
        <footer className="footer">
            <div className="container">
                <div className="footer-top">
                    {/* Columna de Enlaces 1 */}
                    <div className="footer-links">
                        <a href="/">Nosotros</a>
                        <a href="/cursos">Cursos</a>
                        {/* 🔥 2. Validamos si NO hay usuario para mostrar el Login */}
                        {!user && (
                            <span 
                                onClick={openLoginModal} 
                                style={{ cursor: 'pointer' }}
                            >
                                Login
                            </span>
                        )}
                    </div>

                    {/* Columna de Enlaces 2 */}
                    <div className="footer-links">
                        <a href="/empresas">Empresas</a>
                        <a href="/recursos">Recursos</a>
                        <a href="/terminos-y-condiciones">Términos y Condiciones</a>
                        <a href="/politica-de-privacidad">Política de Privacidad</a>

                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-brand">
                        <img
                            src={image_main}
                            alt="One Learning Logo"
                            className="footer-logo"
                        />
                        <p className="copyright">
                            Copyright © One Learning 2026 - Todos los derechos reservados
                        </p>
                    </div>

                    <div className="footer-socials">
                        <a href="mailto:contacto@onelearning.com" className="social-icon"><FaEnvelope /></a>
                        <a href="#" className="social-icon"><FaTwitter /></a>
                        <a href="https://www.linkedin.com/company/one-learning/" className="social-icon"><FaLinkedinIn /></a>
                        <a href="#" className="social-icon-outline"><FaInstagram /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

